import React, { useState, useEffect } from "react";
import LoaderPremiumLogo from "../components/LoaderPremiumLogo";

export default function LoaderGate({ children }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Tiempo premium (1.2–1.5s es estándar empresarial)
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <LoaderPremiumLogo />;

  return children;
}
